module.exports = __webpack_public_path__ + "static/media/mcqs.35a11557.png";